<template>
    <v-app>
        <router-view></router-view>
        <Messages></Messages>
    </v-app>
</template>

<script>

import Messages from './components/common/Messages.vue';
import ErrorDictionary from './constants/errors.js';

export default {
    name: 'app',
    components: {
        Messages,
    },
    mounted(){
        this.$validator.localize('en', ErrorDictionary);
    },
    computed: {
        token() {
            return this.$store.getters['authentication/getToken'];
        },
    },
    watch: {
        token(value) {
            if (value === '') {
                this.$router.push('/auth');
            } else {
                this.$router.push('/');
            }
        },
    },
};

</script>

<style lang="scss">
    @import '~reset-css';
    @import '~roboto-fontface/css/roboto/roboto-fontface.css';
    @import '~vuetify/dist/vuetify.min.css';
    @import '~@fortawesome/fontawesome-free/css/all.css';
    @import './style/App.scss';
</style>
